import { Component, OnInit } from '@angular/core';
import { Representante } from './representantes.model';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { getCurrentLanguage } from '../core/helpers/utils';
import { generalTranslations } from '../core/helpers/translations';

// services
import { EventService } from 'src/app/core/service/event.service';
import { RepresentanteService } from './representantes.service';

// constants
import { EventType } from 'src/app/core/constants/events';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-detail-representante',
  templateUrl: './detail-representante.component.html',
  styleUrls: ['./detail-representante.component.scss']
})
export class DetailRepresentanteComponent implements OnInit {

  constructor(
    private eventService: EventService,
    private representanteService: RepresentanteService,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer) { }

  representante = <Representante>{};
  id!: string | null;
  avatarUrl?: SafeUrl;
  isArbitroDisabled = false;

  ngOnInit(): void {
    this.loadRepresentante();
  }

  loadRepresentante() {
    this.id = this.route.snapshot.paramMap.get('id');
    if (this.id !== null) {
      this.representanteService.getRepresentante(this.id).subscribe(resRepresentante => {
        resRepresentante.nivel_acceso = "REPRESENTANTE";
        this.representante = resRepresentante;
        if (this.representante.es_arbitro) {
          // Si es árbitro, deshabilitar el toggle
          this.isArbitroDisabled = true;
        }
        this.representanteService.getAvatar(resRepresentante.id).subscribe(avatarBlob => {
          if (avatarBlob) {
            const blobUrl = URL.createObjectURL(avatarBlob);
            this.avatarUrl = this.sanitizer.bypassSecurityTrustUrl(blobUrl);
          }
        });
      });
    }
  }

  onSubmit(form: NgForm) {
    const usuario: Representante = {
      nombre: form.value.nombre,
      apellidos: form.value.apellidos,
      email: form.value.email,
      telefono: form.value.telefono,
      nivel_acceso: "USUARIO",
      es_arbitro: form.value.es_arbitro
    }

    if (this.id !== null) {
      this.representanteService.updateRepresentante(this.id, usuario).subscribe(res => {
        if (usuario.es_arbitro) {
          // Después de guardar, si es árbitro, deshabilitar el toggle
          this.representante.es_arbitro = true;
        }
        this.router.navigate(['/representantes']);
      });
    }
  }


  uploadAvatar(id: string, avatar: File) {
    if (id) {
      //this.isSaving = true;      
      const formData = new FormData();
      formData.append('foto', avatar);

      this.representanteService.updateAvatar(id, formData).subscribe({
        next: () => {
          //this.mostrarMensajeGuardado()
          //this.error = '';
          this.refreshAvatar(id);
          this.eventService.broadcast(EventType.UPDATE_AVATAR, { userId: id });
          //console.log("Avatar enviado al back->", formData);
        },
        error: (error: any) => {
          //console.error("Error al guardar árbitro: ", error, id, formData);
          //this.error = error;
          //this.isSaving = false;
        }
      });
    }
  }

  // Se ejecuta cuando hace el value Change en el input de la foto
  onFileChange(event: Event) {

    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files.length > 0) {
        const avatar = input.files[0];
        this.uploadAvatar(id, avatar);
      }
    }

  }

  // Se llama desde el botón para cambiar foto
  triggerFileInput() {
    // Accede al elemento input usando document.getElementById y dispara el clic
    const fileInput = document.getElementById('inputAvatar') as HTMLInputElement;
    fileInput.click();
  }

  refreshAvatar(id: string) {
    this.representanteService.getAvatar(id).subscribe(avatarBlob => {
      if (avatarBlob) {
        const blobUrl = URL.createObjectURL(avatarBlob);
        this.avatarUrl = this.sanitizer.bypassSecurityTrustUrl(blobUrl);
      }
    });
  }

}
